import { useAppSelector } from '~/effects/redux';

import { getFeatureFlags } from '../modules/launchDarkly';

export const useFeatureFlags = () => useAppSelector(getFeatureFlags);
